// extracted by mini-css-extract-plugin
export default {"sectionJumpLinks":"SectionJumpLinks_sectionJumpLinks__pKk7K"};